import { AnchoredLayer } from '@doordash/component-layer-manager';
import { Icon, Inset } from '@doordash/design-language';
import PropTypes from 'prop-types';

var buttonOverridesFromTheme = function buttonOverridesFromTheme(theme) {
  return {
    Colors: {
      ButtonFlatPrimaryForeground: theme.Colors.ToastInformationalAction,
      ButtonFlatPrimaryForegroundDisabled: theme.Colors.ToastInformationalActionDisabled,
      ButtonFlatPrimaryForegroundHovered: theme.Colors.ToastInformationalActionHovered,
      ButtonFlatPrimaryForegroundPressed: theme.Colors.ToastInformationalActionPressed
    },
    Typography: {
      TextStyles: {
        ToastAction: theme.Typography.TextStyles.ToastAction
      }
    }
  };
};
var POSITIONS = {
  TopStart: AnchoredLayer.Positions.TopLeft,
  TopCenter: AnchoredLayer.Positions.TopCenter,
  TopEnd: AnchoredLayer.Positions.TopRight,
  BottomStart: AnchoredLayer.Positions.BottomLeft,
  BottomCenter: AnchoredLayer.Positions.BottomCenter,
  BottomEnd: AnchoredLayer.Positions.BottomRight
};
var DURATIONS = {
  Short: 4000,
  Medium: 6000,
  Long: 10000
};
var TOAST_CONTENT_PROPTYPES = {
  icon: PropTypes.oneOf(Object.values(Icon.Types)),
  isLoading: PropTypes.bool,
  position: PropTypes.oneOf(Object.values(POSITIONS)),
  text: PropTypes.string.isRequired,
  action: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  insetFromEdge: PropTypes.oneOf(Object.values(Inset.Sizes)),
  onHide: PropTypes.func
};

export { DURATIONS, POSITIONS, TOAST_CONTENT_PROPTYPES, buttonOverridesFromTheme };
